import React from 'react';
import PropTypes from 'prop-types';
import { StandoutTile } from 'web-ui-components/lib/layout/content';
import withContent from '../../containers/withContent';
import messageContent, { contentPropTypes } from './StandoutTile.content';

const StandoutTileMessage = ({ showStandoutTile, content }) => {
	if (showStandoutTile) {
		return (
			<StandoutTile.Important>
				<strong>{content.strong}</strong>
				{content.description}
			</StandoutTile.Important>
		);
	}
	return null;
};

StandoutTileMessage.defaultProps = {
	showStandoutTile: false,
};

StandoutTileMessage.propTypes = {
	showStandoutTile: PropTypes.bool,
	content: PropTypes.shape(contentPropTypes),
};

export default withContent({ content: messageContent })(StandoutTileMessage);
export { StandoutTileMessage };
